export const getScript = (url, { parent = 'head', id, type = 'text/javascript' } = {}) => new Promise((resolve, reject) => {
    const parentElement = document.getElementsByTagName(parent)[0];

    if (!parentElement) {
        reject(new Error(`Parent was not found for loading "${url}".`));
    }

    const script = document.createElement('script');
    script.src = url;

    if (id) {
        script.id = id;
    }

    if (type) {
        script.type = type;
    }

    script.onload = (response) => {
        resolve(response);
        script.remove();
    };

    script.onerror = () => {
        reject(new Error(`Script "${url}" loading error.`));
        script.remove();
    };

    parentElement.appendChild(script);
});

export const getStylesheet = url => new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = url;
    link.media = 'all';
    document.head.appendChild(link);

    link.onload = (response) => {
        resolve(response);
    };

    link.onerror = () => {
        reject(new Error(`Stylesheet "${url}" loading error.`));
        link.remove();
    };

    document.head.appendChild(link);
});
